import * as React from 'react'
import { getClassNameModern } from '../../../../../../Shared/Frontend/utils/getClassNameFromStyle'
import { fixTableStructure } from '../../../utils/html'
import type { TextBlockNested } from '../../modernBlocks.state'

export type TextBlockNestedClassNames = Partial<{
  block: string
  inview: string
  inner: string
  content: string
  text: string
}>

export const textBlockNestedClasses: TextBlockNestedClassNames = {
  block: 'block--nested block--text-nested',
  inner: 'block__inner',
  content: 'block__content',
  text: 'block__text text--styled',
}

export const TextBlockNestedLayout = (props: TextBlockNested) => {
  const { body, index } = props
  return (
    <div key={index} className={getClassNameModern(textBlockNestedClasses, 'block', '')}>
      <div className={getClassNameModern(textBlockNestedClasses, 'inner', 'pt-3')}>
        {body && (
          <div className={getClassNameModern(textBlockNestedClasses, 'content', '')}>
            <div
              className={getClassNameModern(textBlockNestedClasses, 'text', '')}
              dangerouslySetInnerHTML={{ __html: fixTableStructure(body) }}
            />
          </div>
        )}
      </div>
    </div>
  )
}